/**
 * Uma conexão por sessão. O JWT vai no primeiro frame, nunca na query string.
 * Se o socket cair, o chamador volta ao polling HTTP.
 */
export function startDomainSocket({ url, getToken, getSince, onEvent, onOpen, onClose }) {
  let socket = null;
  let closed = false;
  let opened = false;
  let reconnectTimer = null;
  let attempt = 0;

  const connect = () => {
    if (closed) return;
    try {
      socket = new WebSocket(url);
    } catch (error) {
      scheduleReconnect();
      return;
    }

    socket.onopen = () => {
      const token = getToken();
      if (!token) {
        socket.close();
        return;
      }
      socket.send(JSON.stringify({
        op: 'auth',
        token,
        since: getSince(),
      }));
    };

    socket.onmessage = (message) => {
      let payload;
      try {
        payload = JSON.parse(message.data);
      } catch (error) {
        return;
      }
      if (!payload || typeof payload !== 'object') return;
      if (payload.op === 'ready') {
        attempt = 0;
        if (!opened) {
          opened = true;
          onOpen();
        }
        return;
      }
      if (payload.op === 'event' && payload.event) {
        onEvent(payload.event);
        return;
      }
      if (payload.op === 'ping' && socket && socket.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify({ op: 'pong' }));
      }
    };

    socket.onclose = () => {
      socket = null;
      if (opened) {
        opened = false;
        onClose();
      }
      scheduleReconnect();
    };

    socket.onerror = () => {
      socket?.close();
    };
  };

  const scheduleReconnect = () => {
    if (closed || reconnectTimer) return;
    const delay = Math.min(15000, 1000 * (2 ** attempt));
    attempt += 1;
    reconnectTimer = window.setTimeout(() => {
      reconnectTimer = null;
      connect();
    }, delay);
  };

  connect();

  return {
    close() {
      closed = true;
      if (reconnectTimer) {
        window.clearTimeout(reconnectTimer);
        reconnectTimer = null;
      }
      if (socket) {
        socket.onclose = null;
        socket.close();
        socket = null;
      }
      if (opened) {
        opened = false;
        onClose();
      }
    },
  };
}
